import type { FAQ } from 'src/components/FaqAccordion/FaqAccordion';

export const faqs: FAQ[] = [
  {
    question: 'Who should advertise on SEEK Business?',
    answer:
      'Anybody who owns a business and would like to sell a business online by liaising directly with buyers.',
  },
  {
    question: 'How long will it take me to sell my business?',
    answer:
      'On average, it takes 6–9 months to sell, sometimes more, especially if your business is valued at $1 million or more.',
  },
  {
    question: 'Do you charge commission?',
    answer: 'No, we do not charge commission and there are no hidden fees.',
  },
  {
    question: 'How can I access resources before listing my business?',
    answer:
      "Register with SEEK Business to access our helpful resources, such as our value calculator guide. Then purchase an ad pack if and when you're ready to sell a business.",
  },
  {
    question: 'What are the daily buyer recommendation emails?',
    answer:
      "Each day, we send personalised emails to registered buyers featuring businesses that match their specific interests. These recommendations help your business catch buyers' attention even when they're not actively browsing the SEEK Business website.",
  },
  {
    question: 'What are featured ads?',
    answer:
      "Featured ads are given priority position in search results and buyer emails. These are cycled through one of two 'Featured' slots at the top of relevant search results and at the top of our recommended business buyer emails. Featured ads give your business more prominence, reach a broader audience and receive enquiries more quickly compared to standard ad listings.",
  },
  {
    question: 'Will my ad be placed on other websites?',
    answer:
      'No, when you advertise with SEEK Business your ad is only displayed on our website.',
  },
];
